<template>
  <div class="inner-navigation">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'inner-navigation',
};
</script>

<style lang="scss" scoped>
.inner-navigation {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  font-size: 1.1em;

  & > a {
    margin-right: 20px;
    text-decoration: none;
    padding: 10px 0;
    border-bottom: 1px solid transparent;

    &.router-link-active {
      border-bottom: 1px solid;
    }
  }

  button {
    margin-right: 0;
    margin-left: auto;
  }
}
</style>
